export default __webpack_public_path__ + "static/media/selvi-kapak.fd42019b.jpg";